<script setup>
import { computed } from "vue";

const props = defineProps({
  resident: {
    type: Object,
    required: true,
  },
});

const formatDate = (value) => {
  if (!value) return "-";
  return new Intl.DateTimeFormat("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date(value));
};

const residentTypeText = (type) => {
  const map = { owner: "เจ้าของ", tenant: "ผู้เช่า" };
  return map[type] || type;
};

const occupancyText = (status) => {
  const map = { active: "กำลังพักอาศัย", inactive: "ย้ายออก/ไม่อยู่" };
  return map[status] || status;
};

const paymentStatusText = (status) => {
  const map = {
    paid: "ชำระแล้ว",
    partial: "ชำระบางส่วน",
    overdue: "ค้างชำระ",
    pending: "รอชำระ",
  };
  return map[status] || status;
};

const paymentBadgeClass = (status) => {
  const map = {
    paid: "text-bg-success",
    partial: "text-bg-warning",
    overdue: "text-bg-danger",
    pending: "text-bg-secondary",
  };
  return map[status] || "text-bg-light";
};

const infoItems = computed(() => [
  { label: "รหัสลูกบ้าน", value: props.resident.residentCode },
  { label: "ชื่อ-นามสกุล", value: props.resident.name },
  { label: "ประเภท", value: residentTypeText(props.resident.residentType) },
  {
    label: "สถานะการพักอาศัย",
    value: occupancyText(props.resident.occupancyStatus),
  },
  { label: "วันที่เข้าอยู่", value: formatDate(props.resident.moveInDate) },
  { label: "ชำระล่าสุด", value: formatDate(props.resident.lastPaymentDate) },
]);
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">ข้อมูลลูกบ้าน</h5>
          <div class="text-muted small">ข้อมูลส่วนตัวและการอยู่อาศัย</div>
        </div>
        <span
          class="badge rounded-pill"
          :class="paymentBadgeClass(resident.paymentStatus)"
        >
          {{ paymentStatusText(resident.paymentStatus) }}
        </span>
      </div>

      <div class="row g-3">
        <div class="col-md-6" v-for="item in infoItems" :key="item.label">
          <div class="label-text">{{ item.label }}</div>
          <div class="value-text">{{ item.value }}</div>
        </div>
      </div>

      <div class="mt-4 pt-4 border-top">
        <div class="label-text mb-2">หมายเหตุ</div>
        <div class="text-muted">{{ resident.note || "-" }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.label-text {
  font-size: 0.82rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
}
.value-text {
  font-weight: 600;
}
</style>
